import React from 'react';
import { Icon } from '../../30-components/menu/Icon';
import { Authors } from '../../50-systems/ModuleStore/Authors';
import { internalModules } from '../../50-systems/ModuleStore/internalModules';
import { makeAttributeModule } from '../../50-systems/ModuleStore/makers/makeAttributeModule';

/**
 *
 * Note: In future this file will we in independent repository as external module.
 *
 */
internalModules.declareModule(() =>
    makeAttributeModule({
        manifest: {
            name: 'curtainVisibleAttribute',

            contributors: [Authors.rosecky],
        },
        standard: true,
        attribute: {
            // @rosecky Probbably not ideal way how to name attributes - please discuss with @hejny
            type: 'number',
            name: 'curtainVisible',
            defaultValue: 1,
        },
        inputRender(value: number, onChange: (value: number) => void) {
            return (
                <>
                    <Icon icon="visibility" active={value === 1 ? true : false} onClick={() => onChange(-1)} />
                </>
            );
        },
    }),
);
